<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <!--<e-item-->
          <!--prefixIcon="icon hero-icon hero-icon-add-peer"-->
          <!--:tooltipText="$t('SubscriberIms.addSiblingNode')"-->
          <!--:click="addChildNodeClk"-->
          <!--operate="add_node"-->
        <!--&gt;</e-item>-->
        <e-item
          prefixIcon="icon hero-icon hero-icon-add-children"
          :tooltipText="$t('SubscriberIms.addChildNode')"
          :click="addChildNodeClk"
          operate="add_child_node"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-edit"
          :tooltipText="$t('SubscriberIms.mod')"
          :click="modifyNodeClk"
          operate="edit_node"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-remove"
          :tooltipText='$t("SubscriberIms.del")'
          :click="deleteNodeClk"
          operate="del"
        ></e-item>
        <e-item
          prefixIcon="icon hero-icon hero-icon-refresh"
          :tooltipText="$t('SubscriberIms.fresh')"
          :click="refreshNodeClk"
          operate="refresh"
        ></e-item>
        <!--<e-item
          prefixIcon="icon hero-icon hero-icon-sort"
          :tooltipText="$t('SubscriberIms.sortBtn')"
          :click="sortClk"
          operate="sort"
        ></e-item>-->
      </e-items>
    </ejs-toolbar>
    <!-- 添加节点 -->
    <CustomDialog ref="addChildNodeDialog" :element="addChildNodeDialogSetting.element" :styles="addChildNodeDialogSetting.styles">
      <template v-slot:dialog-content>
        <AddVpnInfoDialog ref="addNodeDetail"></AddVpnInfoDialog>
      </template>
    </CustomDialog>

    <!-- 修改节点 -->
    <CustomDialog
      ref="modifyChildNodeDialog"
      :element="modifyChildNodeDialogSetting.element"
      :styles="modifyChildNodeDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <AddVpnInfoDialog ref="modifyNodeDetail" :modifyParams="modifyParamsData"></AddVpnInfoDialog>
      </template>
    </CustomDialog>

    <ejs-dialog
      :buttons="dialogParams.confirmDlgButtons"
      ref="confirmDialog"
      v-bind:visible="false"
      :header="dialogParams.confirmHeader"
      :animationSettings="dialogParams.animationSettings"
      :content="dialogParams.confirmContent"
      :showCloseIcon="dialogParams.confirmCloseIcon"
      :open="dialogOpen"
      :close="dialogClose"
      :target="dialogParams.target"
      :width="dialogParams.confirmWidth"
    ></ejs-dialog>
  </div>
</template>

<script>
import CustomDialog from '../../common/CustomDialog';
import AddVpnInfoDialog from './vpn/AddVpnInfoDialog';
import { EventBus } from '../../../plugins/eventBus';
import commonJS from './common';


export default {
  name: 'OrganizationalIcon',
  components: {
    CustomDialog,
    AddVpnInfoDialog,
    EventBus
  },
  props: [
    'treeFresh'
  ],
  data() {
    return {
      opCodeList: {
        addVpnCode: '27803',
        modVpnCode: '27804',
        delVpnCode: '27805',
        qryVpnCode: '27806'
      },
      titleEnum: {
        add_node: this.$t('SubscriberIms.addSiblingNode'),
        add_child_node: this.$t('SubscriberIms.addChildNode'),
      },
      dialog: {
        styles: {
          width: '400px',
          height: '320px',
          model: true,
          visible: false
        }
      },
      addChildNodeDialogSetting: {
        styles: {
          width: '400px',
          height: '550',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('SubscriberIms.addSiblingNode'),
          target: '#app',
          refName: 'addchildnode',
          isClose: false,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('SubscriberIms.cancel') } },
            {
              click: this.submitAddNode,
              buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
            }
          ]
        }
      },
      modifyChildNodeDialogSetting: {
        styles: {
          width: '400px',
          height: '620',
          model: true,
          visible: false
        },
        element: {
          title: this.$t('SubscriberIms.modifyNode'),
          target: '#app',
          refName: 'modifynode',
          isClose: false,
          buttonGroup: [
            { click: this.dialogHide, buttonModel: { content: this.$t('SubscriberIms.cancel') } },
            {
              click: this.submitModifyNode,
              buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
            }
          ]
        }
      },
      // addNodeType = 0 子节点  type = 1 平级节点
      addNodeType: undefined,
      modifyParamsData: {
        vpnname: undefined,
        orgcode: undefined,
        vpnid: undefined
      },
      // 删除时确认对话框
      dialogParams: {
        confirmHeader: this.$t('SubscriberIms.reminder'),
        animationSettings: { effect: 'None' },
        confirmContent: `<span>${this.$t('SubscriberIms.deleteConfirm')}</span>`,
        confirmCloseIcon: true,
        target: '#app',
        confirmWidth: '400px',
        confirmDlgButtons: [
          { click: this.promptDlgBtnClick, buttonModel: { content: this.$t('SubscriberIms.cancel') } },
          {
            click: this.confirmDlgBtnClick,
            buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }
          }
        ]
      },
      sortIdAndVpnidArray: [],
      sortIdAndVpnidOfNeidMap: new Map(),
      fuzzyFlag: false,
    };
  },
  methods: {
    refreshNodeClk() {
      this.$parent.getOrganizationalTree();
      //this.treeFresh();
      this.$parent.nodeSelect = undefined;
    },
    addChildNodeClk(args) {
      const node = this.$parent.getNodeSelected();
      if (!node) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.chooseNodeTip') });
        return;
      }
      if (args.item.operate === 'add_node') {
        this.addNodeType = 1;
        const id = parseInt(node.id.split('_')[2], 0);
        if (id === 0) {
          // this.$layer.alert({ msg: this.$t('SubscriberIms.notChooseRootTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.notChooseRootTip') });
          return;
        }
        this.addChildNodeDialogSetting.element.title = this.titleEnum.add_node;
      }
      if (args.item.operate === 'add_child_node') {
        this.addNodeType = 0;
        this.addChildNodeDialogSetting.element.title = this.titleEnum.add_child_node;
      }
      const neidVal = parseInt(node.id.split('_')[0], 0);
      // this.$refs.addChildNodeDialog.show();
      const param = { msgid: 46100, neid: neidVal,serviceType: 'microPoc' };
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', param).then((response) => {
        if (response.status === 200) {
          console.log(response.data.resultVal);
          this.$refs.addChildNodeDialog.show();
          this.$refs.addNodeDetail.mainHandler([], response, { opCode: 'add' },(parseInt(node.id.split('_')[2], 0)+1).toString());
        } else {
          this.$refs.addChildNodeDialog.close();
          // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        }
      });
    },
    async modifyNodeClk() {
      const _this = this;
      const node = this.$parent.getNodeSelected();
      if (!node) {
        // _this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: _this.$t('SubscriberIms.chooseNodeTip') });
        return;
      }
      const vpnid = node.id.split('_')[2];
      if (vpnid === '0' || vpnid === 0) {
        // _this.$layer.alert({ msg: this.$t('SubscriberIms.notModRootTip') });
        EventBus.$emit('toast', { type: 'warning', content: _this.$t('SubscriberIms.notModRootTip') });
        return;
      }
      const neidVal = node.id.split('_')[0];
      const vpnNode = await _this.$parent.queryById(vpnid, neidVal);
      _this.modifyParamsData.vpnName = vpnNode.vpnName;
      _this.modifyParamsData.orgCode = vpnNode.orgCode;
      _this.modifyParamsData.vpnId = vpnNode.vpnId;
      _this.modifyParamsData.groupCount = vpnNode.groupCount === "4294967295"?"":vpnNode.groupCount;
      _this.modifyParamsData.userCount = vpnNode.userCount === "4294967295"?"":vpnNode.userCount;
      _this.modifyParamsData.audioMax = vpnNode.audioMax === "4294967295"?"":vpnNode.audioMax;
      _this.modifyParamsData.videoMax = vpnNode.videoMax === "4294967295"?"":vpnNode.videoMax;

      const paramArray = [];
      paramArray.push(_this.modifyParamsData);
      const param = { msgid: 46101, neid: neidVal,serviceType: 'microPoc'};
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', param).then((response) => {
        if (response.status === 200) {
          console.log(response.data.resultVal);
          this.$refs.modifyChildNodeDialog.show();
          this.$refs.modifyNodeDetail.mainHandler(_this.modifyParamsData, response, { opCode: 'mod' },vpnNode.vpnLevel);
        } else {
          this.$refs.modifyChildNodeDialog.close();
          // this.$layer.alert({ msg: this.$t('SubscriberIms.requestResTip') });
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        }
      });
    },
    deleteNodeClk() {
      const _this = this;
      const node = this.$parent.getNodeSelected();
      if (!node) {
        // _this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        EventBus.$emit('toast', { type: 'warning', content: _this.$t('SubscriberIms.chooseNodeTip') });
        return;
      }
      this.$refs.confirmDialog.show();
    },
    dialogHide() {
      this.$refs.addChildNodeDialog.close();
      this.$refs.modifyChildNodeDialog.close();
    },
    submitAddNode() {
      // const params = this.$refs.addNodeDetail.getAddNodeFromData();
      const params = this.$refs.addNodeDetail.getDatas();
      if (!params) {
        return;
      }
      this.$parent.lteAddVpnMethod(params, this.addNodeType);
      this.dialogHide();
    },
    submitModifyNode() {
      // const params = this.$refs.modifyNodeDetail.getModifyNodeFromData();
      const params = this.$refs.modifyNodeDetail.getDatas();
      if (!params) {
        return;
      }
      this.$parent.lteModVpnMethod(params);
      this.dialogHide();
    },
    dialogClose() {
      // alert("dialogClose");关闭dialogs时处理的预留函数
    },
    dialogOpen() {
      // alert("dialogOpen");弹出dialogs时处理的预留函数
    },
    confirmDlgBtnClick() {
      this.$refs.confirmDialog.hide();
      this.$parent.lteDelVpnMethod();
    },
    promptDlgBtnClick() {
      this.$refs.confirmDialog.hide();
    },
    // 按层级判断是否有变化
    findIratSortLevel(initDataArray, dataArray) {
      let difFlag = false;
      initDataArray.forEach((item, index) => {
        if (item.id_show !== dataArray[index].id_show) {
          difFlag = true;
        }
      });
      if (difFlag) {
        let sortId = 1;
        const _neid = dataArray[0].id_show.split('_')[0];
        dataArray.forEach((item) => {
          const _vpnid = item.id_show.split('_')[2];
          const vpnidSortId = {};
          vpnidSortId.neid = _neid;
          vpnidSortId.vpnid = _vpnid;
          vpnidSortId.sortid = sortId;
          this.sortIdAndVpnidArray.push(vpnidSortId);
          sortId++;
        });
        if (this.sortIdAndVpnidOfNeidMap.get(_neid) === undefined) {
          this.sortIdAndVpnidOfNeidMap.set(_neid, _neid);
        }
      }
      initDataArray.forEach((item, index) => {
        if (item.children !== null) {
          const tempData = dataArray.filter((ii) => ii.id_show === item.id_show );
          this.findIratSortLevel(item.children, tempData[0].children);
        }
      });
    },
    sortClkNew(args) {
      this.sortIdAndVpnidArray = [];
      this.sortIdAndVpnidOfNeidMap = new Map();
      const afterData = this.$parent.$refs.tree1.getTreeData(); // drag后的数据
      const beforeData = this.$parent.initData;// 原始数据
      beforeData.forEach((item, index) => {
        if (item.children) {
          this.findIratSortLevel(item.children, afterData[index].children);
        }
      });
      // 循环遍历数组---找到有变化的层级，进行排序
      this.saveSortIdOfVpn(this.sortIdAndVpnidArray, this.sortIdAndVpnidOfNeidMap);
    },
    sortClk() {
      this.fuzzyFlag = this.$parent.fuzzyFlag;
      if (this.fuzzyFlag) {
        // this.$layer.alert({ msg: '模糊查询不支持排序' });
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.fuzzyQryNotApplSort') });
        return;
      }
      const uls = document.getElementById('tree1').querySelectorAll('ul');
      const neidMap = new Map();
      const vpnIdWithSortIdArray = new Array();
      if (uls && uls.length > 1) {
        for (let i = 1; i < uls.length; i++) {
          let sortId = 1;
          console.log(uls[i], uls[i].querySelectorAll('li'), uls[i].querySelectorAll('li').length);
          const li = uls[i].querySelectorAll('li');
          if (li.length > 1) {
            const liTemp = [];
            const firstNode = uls[i].querySelector('li');
            const levelT = firstNode.getAttribute('aria-level');
            const _neid = firstNode.getAttribute('data-uid').split('_')[0];
            li.forEach((item) => {
              if (item.getAttribute('aria-level') === levelT) {
                liTemp.push(item);
              }
            });
            liTemp.forEach((item) => {
              const nodeVpnId = item.getAttribute('data-uid');
              const _vpnid = nodeVpnId.split('_')[2];
              if (item.getAttribute('sortable')) {
                const vpnidSortId = {};
                vpnidSortId.neid = _neid;
                vpnidSortId.vpnid = _vpnid;
                vpnidSortId.sortid = sortId;
                sortId++;
                vpnIdWithSortIdArray.push(vpnidSortId);
              }
            });
            if (neidMap.get(_neid) === undefined) {
              neidMap.set(_neid, _neid);
            }
          }
        }
      }
      console.log(neidMap, neidMap.size, vpnIdWithSortIdArray);
      this.saveSortIdOfVpn(vpnIdWithSortIdArray, neidMap);
    },
    saveSortIdOfVpn(vpnIdWithSortIdArray, neidMap) {
      if (vpnIdWithSortIdArray && vpnIdWithSortIdArray.length > 0) {
        this.$loading.showLoadding();
        const len = neidMap.size;
        let count = 0;
        const showValue = new Map();
        const neinfoMap = this.$parent.getNeinfoMap();
        neidMap.forEach((item) => {
          const showObj = { operate: neinfoMap.get(parseInt(item, 0)).equipmentName };
          showValue.set(item, showObj);
          const paramMap = {
            info: { neid: item, msgid: 27843 },
            vo: { page: 1, count: vpnIdWithSortIdArray.length, msgid: 27843, resultList: vpnIdWithSortIdArray },
          };
          console.log('neid=', item, paramMap);
          this.$axios.post('/lte/ems/subscriber/imsunms/requestCommonMicro', paramMap).then((response) => {
            count++;
            if (response.status === 200 && response.data.resultVal !== null) {
              console.log(response.data.resultVal[0].display);
              showValue.get(paramMap.info.neid).operResult = response.data.resultVal[0].display;
              console.log(showValue, JSON.stringify(showValue));
            }
            if (count === len) {
              this.$loading.hideLoadding();
              let tips = '';
              showValue.forEach((item) => {
                tips = `${tips}${item.operate}&nbsp&nbsp${item.operResult}\n`;
              });
              // this.$layer.alert({ msg: tips });
              EventBus.$emit('toast', { type: 'infomation', content: tips });
              this.$parent.getOrganizationalTree();
            }
          });
        });
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.noSortVpn') });
      }
    }
  }
};
</script>
